(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-product-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rakhi-story]').forEach((story) => {
    if (story.dataset.motionReady === 'true') return;
    story.dataset.motionReady = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    story.classList.add('is-ready');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -7% 0px' }
    );

    story.querySelectorAll('[data-reveal]').forEach((item) => observer.observe(item));
  });

  } catch(e) { console.error(e); }
})();
})();
